window.customerQuotesSlider = customerQuotesSlider;

function customerQuotesSlider (options) {
	let defaultOptions =  {
		loop : false,
		draggable : true,
		mouseWheel : false,
		autoplay : false,
		stopAutoplayWhenHover : true,
		elementId : ''
	}
	options = {...defaultOptions, ...options};
	let container = document.getElementById(options.elementId);
	for (const [key, value] of Object.entries(options)) {
		if(container.dataset[key]){
			if(container.dataset[key] === 'true' || container.dataset[key] === 'false'){
				options[key] = (container.dataset[key] === "true");
			} else {
				options[key] = parseInt(container.dataset[key]);
			}
		}
	}
	let _this = this;

	container.carousel = container.querySelector('.js-customer-quotes-sliderContainer');
	container.index = 0;
	container.carouselItem = container.carousel.children;
	container.numberOfItem = container.carouselItem.length;
	container.step = container.carouselItem[0].getBoundingClientRect().width;
	container.loop = options.loop;
	if (container.loop) {
		container.index = 1
		container.carousel.style.transform = `translate3d(${
			-container.index * container.step
		}px,0,0)`;
		for (let i = 0; i < 1; i++) {
			let cloneNode = container.carouselItem[i].cloneNode(true);
			container.carousel.insertAdjacentElement("beforeend", cloneNode);
		}
		let count = 0;
		while (count !== 1) {
			let cloneNode = container.carouselItem[container.numberOfItem - 1].cloneNode(
				true
			);
			container.carousel.insertAdjacentElement("afterbegin", cloneNode);
			count++;
		}
		container.querySelector(".js-prev").style.display = "block";
		container.querySelector(".js-next").style.display = "block";

		container.carousel.style.justifyContent = "normal"
	}

	container.translateSlide = () => {
		container.carousel.style.transform = `translate3d(${
			-container.index * container.step
		}px,0,0)`;
		if (!container.loop) {
			if(container.index + 1 === container.numberOfItem ){
				container.querySelector(".js-prev").style.display = "block";
				container.querySelector(".js-next").style.display = "none";
			} else if(container.index === 0){
				container.querySelector(".js-prev").style.display = "none";
				container.querySelector(".js-next").style.display = "block";
			} else {
				container.querySelector(".js-prev").style.display = "block";
				container.querySelector(".js-next").style.display = "block";
			}
		}
		let dotNumber = container.index;
		if (container.loop && (container.index > container.numberOfItem ))
			dotNumber = 1;
		else if (container.loop && container.index < 1)
			dotNumber = container.numberOfItem
		else if(!container.loop)
			dotNumber += 1
		for (const dotNavigation of container.querySelectorAll('.js-dot')) {
			dotNavigation?.classList.remove('!bg-blue-black')
		}

		container.querySelector(".js-dot[data-position='" + dotNumber + "']")?.classList.add('!bg-blue-black')
	};

	container.resetSlide = (step) => {
		if (container.index + step < 1) container.index = container.numberOfItem + 1;
		if (container.index + step >= container.numberOfItem + 1)
			container.index = 0;
		container.carousel.style.transition = "none";
		container.translateSlide();
		setTimeout(() => {
			container.carousel.style.transition = "all 0.25s";
			container.index += step;
			container.translateSlide();
		}, 20);
	};

	container.moveSlide = (step) => {
		container.carousel.style.transition = "all 0.25s";
		//every time we move slide, add transition
		if (container.loop) {
			if (
				container.index + step < 1 ||
				container.index + step >= container.numberOfItem + 1
			) {
				container.resetSlide(step);
			} else {
				container.index += step;
				container.translateSlide();
			}
		} else {
			if (
				container.index + step < 0 ||
				container.index + step > container.numberOfItem - 1
			)
				return;
			else {
				container.index += step;
				container.translateSlide();
			}
		}
	};

	container.querySelector(".js-prev").addEventListener("click", () => {
		container.moveSlide(-1);
	});
	container.querySelector(".js-next").addEventListener("click", () => {
		container.moveSlide(1);
	});

	for (const dotNavigation of container.querySelectorAll('.js-dot')) {
		dotNavigation.addEventListener("click", event => {
			container.carousel.style.transition = "all 0.25s";
			let step = parseInt(event.target.dataset.position);
			if (!container.loop) step -= 1
			container.index = step;
			container.translateSlide();
		});
	}

	if (options.draggable) {
		let firstPos = (currentPos = 0);

		let dragStartHandle = (e) => {
			container.carousel.style.transition = "none";
			if (e.type === "touchstart") {
				currentPos = e.touches[0].clientX;
				document.addEventListener("touchmove", dragHandle);
				document.addEventListener("touchend", dragEndHandle);
			} else {
				container.style.cursor = "grab";
				currentPos = e.clientX;
				document.addEventListener("mousemove", dragHandle);
				document.addEventListener("mouseup", dragEndHandle);
			}
			firstPos = currentPos;
			//add necessary listener, style, reset first and current position
			if (options.autoplay > 0) {
				clearInterval(intervalId);
				clearTimeout(timeoutId);
			}
		};

		let dragHandle = (e) => {
			let currentMove = parseFloat(
				container.carousel.style.transform.slice(12)
			);
			if(isNaN(currentMove)){currentMove = 0}
			let currentIndex = -currentMove / container.step;

			let x = e.type === "touchmove" ? e.touches[0].clientX : e.clientX; //get current coordinate
			let distanceMoved = x - currentPos;
			if (container.loop) {
				if (currentIndex <= 0) {
					container.index = container.numberOfItem;
					container.translateSlide();
				} else if (
					currentIndex >=
					container.numberOfItem + 1
				) {
					container.index = 1
					container.translateSlide();
				} else
					container.carousel.style.transform = `translate3d(${
						currentMove + distanceMoved
					}px,0,0)`;
			} else {
				if (
					currentIndex < 0 ||
					currentIndex > container.numberOfItem - 1
				)
					container.carousel.style.transform = `translate3d(${
						currentMove + distanceMoved / 5
					}px,0,0)`;
				//when user drag out of bound, decrease speed
				else
					container.carousel.style.transform = `translate3d(${
						currentMove + distanceMoved
					}px,0,0)`;
			}
			currentPos = x;
		};

		container.checkIndex = (currentMove) => {
			let temp = currentMove;
			while (temp >= container.step) {
				temp -= container.step;
			}
			if (
				(temp > 50 && firstPos - currentPos >= 0) ||
				(container.step - temp < 50 && firstPos - currentPos <= 0)
			)
				return Math.ceil(currentMove / container.step);
			return Math.floor(currentMove / container.step);
		};

		let dragEndHandle = (e) => {
			if (e.type === "touchend") {
				document.removeEventListener("touchmove", dragHandle);
				document.removeEventListener("touchend", dragEndHandle);
			} else {
				document.removeEventListener("mousemove", dragHandle);
				document.removeEventListener("mouseup", dragEndHandle);
				container.style.cursor = "auto";
			}
			//remove unnecessary event listener and style
			let currentMove = parseFloat(
				container.carousel.style.transform.slice(12)
			);
			container.index = container.checkIndex(-currentMove);
			if (!container.loop) {
				if (container.index > container.numberOfItem - 1)
					container.index = container.numberOfItem - 1;
				if (container.index < 0) container.index = 0;
			}
			container.carousel.style.transition = "all 0.25s";
			container.translateSlide();
			if (options.autoplay > 0) {
				clearInterval(intervalId);
				clearTimeout(timeoutId);
				timeoutId = setTimeout(() => {
					intervalId = setInterval(container.moveSlide, options.autoplay, 1);
				}, 2000);
			}
		};

		container.addEventListener("mousedown", dragStartHandle);
		container.addEventListener("touchstart", dragStartHandle);
	}

	let intervalId;
	let timeoutId;

	if (options.autoplay > 0) {
		timeoutId = setTimeout(() => {
			intervalId = setInterval(container.moveSlide, options.autoplay, 1);
		}, 3000);
		if (options.stopAutoplayWhenHover) {
			container.addEventListener("mouseenter", () => {
				clearTimeout(timeoutId);
				clearInterval(intervalId);
			});
			container.addEventListener("mouseleave", () => {
				clearInterval(intervalId);
				clearTimeout(timeoutId);
				timeoutId = setTimeout(() => {
					intervalId = setInterval(container.moveSlide, options.autoplay, 1);
				}, 2000);
			});
		}
	}
}

function debounceSlider(fn, delay) {
	let id = null;
	return function (args) {
		clearTimeout(id);
		id = null;
		id = setTimeout(function () {
			fn.call(this, args);
		}, delay);
	};
}

function responsiveSlider() {
	let crsContainer = document.querySelectorAll(".js-customer-quotes-slider");
	let containerArray = Array.from(crsContainer);
	containerArray.forEach((item) => {
		if(!item.carouselItem){
			return false;
		}
		item.step = item.carouselItem[0].getBoundingClientRect().width;
		item.translateSlide();
	});
}

window.addEventListener("resize", debounceSlider(responsiveSlider, 500));
//reduce the number of execution for performance

